import React from 'react';
import { mockMutualFunds } from '../../utils/mockMutualFunds';
import styles from './MutualFundList.module.css'; // Updated CSS import
import { Link } from 'react-router-dom';

const MutualFundList = () => { // Updated component name
  const getInitials = (name) => (name ? name.charAt(0).toUpperCase() : '');

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>All Mutual Funds</h1>
        <p>{mockMutualFunds.length} funds</p>
      </div>
      <div className={styles.list}>
        {mockMutualFunds.map(fund => (
          <Link to={`/mutual-funds/invest/${fund.id}`} className={styles.row} key={fund.id}>
            <div className={styles.fundInfo}>
              <div className={styles['fund-initials']}>{getInitials(fund.name)}</div>
              <div>
                <p className={styles.fundName}>{fund.name}</p>
                <p className={styles.fundCategory}>{fund.category} &middot; {fund.rating} &#9733;</p>
              </div>
            </div>
            <div className={styles.fundReturns}>
              <p className={styles.returns}>{fund.returns['3Y'] ? `${fund.returns['3Y']}%` : 'NA'}</p>
              <p className={styles.returnsLabel}>3Y</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MutualFundList; // Updated export name